import { Constants } from "ag-grid-community";
import { atom } from "recoil";

//Constant used for CLIENT_TYPE
export const MID_TERM = 1;
export const SUBSCRIPTIONS =2;
export const JLR = 3;
export const RETAIL = 4;
export const CORPORATE = 5;
export const REPLACEMENT = 6;
export const TOUR_OPERATORS = 7;
export const OTHER = 8;
//End constants - client type

//Constants used for CAUSALS
export const CAUSAL_FAILURE  = 'DMR';
export const CAUSAL_MISAPPROPRIATION = 'DAI';
export const CAUSAL_SUSPICIOUS = 'DF';
export const CAUSAL_NONPAYMENT = 'DMP';
export const CAUSAL_NOTIFICATION = 'DJ';
export const CAUSAL_VIOLATIONS = 'DTC';
export const CAUSAL_ADVERS = 'DAM';
export const CAUSAL_OTHER = 'DO';
export const CAUSAL_IMPROPER = 'DIA';
export const CAUSAL_SUBNOLO = 'DSUB';
export const CAUSAL_SINISTER = 'DSX';
//End contants - causal

//Constants for Entry Source
export const MANUAL = 0;
export const FCA_BANK = 1;
export const AUTOMATIC = 2;
// End constants - Entry Source

//Constants for FCA BANK
export const FCA_BANK_5  = "5";
export const FCA_BANK_10 = "10";
export const FCA_BANK_30 = "30";
export const FCA_BANK_32 = "32";
export const FCA_BANK_35 = "35";
export const FCA_BANK_50 = "50";
//End constants - FCA Bank Origin

export const CREATED = "created";
export const IN_PROGRESS = "inProgress";
export const NOT_FOUND = "notFound";
export const RECOVERED = "recovered";

//Status constants
export const STATUS_CREATED = 1;
export const STATUS_IN_PROGRESS = 2;
export const STATUS_NOT_FOUND = 3;
export const STATUS_FOUND = 4;
export const STATUS_UNDER_SEIZURE = 5;
export const STATUS_RELEASE = 6;
export const STATUS_RECOVERED = 7;

export const THEFT = 0;
export const MISAPPROPRIATION = 1;

export const STATUS_TO_INVOICE = 1;
export const STATUS_SENT_TO_INVOICE = 2;
export const STATUS_PAID_INVOICE = 3;

export const FINE_TYPE_PENALTIES = 'PENALTIES';
export const FINE_TYPE_PARKING_FINES = 'PARKING_FINES';

export const LEGAL_ENTITY_FR = "drivalia_fr";

export const STATE_ACTIVE_TAB = atom<number>({
    key: 'state-active-tab',
    default: 0
});

export const customerBlackListDetails = atom({
    key: 'customerBlackListDetails'
})

export const STATE_SUMMARY_UPDATING = atom<boolean>({
    key: 'fs-state-summary-updating',
    default: false
});

export const FISCAL_CODE_REG_EXP = /^[A-Za-z]{6}[0-9]{2}[A-Za-z][0-9]{2}[A-Za-z][0-9]{3}[A-Za-z]$/
export const VAT_REG_EXP = /^[0-9]{11}$/
export const DECIMAL_REG_EXP =  /^\s*-?[0-9]\d*(\.\d{0,2})?\s*$/
export const INTEGER_REG_EXP =  /^\d+$/
export const INTEGER_6_DIGIT_REG_EXP =  /^[0-9]{6}$/
export const ALPHANUMERIC_REG_EXP =  /^[a-zA-Z0-9_]*$/
export const MAIL_ADDRESS_REG_EXP =  /^[\w\-\.+]+@([\w\-]+\.)+[\w\-]{2,4}$/

export const TELEPHONE_REG_EXP =  /^\+*\d+$/

export default Constants;